import Vuex from "vuex";

export default {

  methods: {
      can(ability) {
          return window.App.permissions.includes(ability.toLowerCase())
      },
      isRole(roleName) {

          var profile = this.$store.state.profile;

          if (profile && profile.me && profile.me.roles && profile.me.roles.length > 0) {
              var role = profile.me.roles[0]['name'];

              return role.toLowerCase() === roleName.toLowerCase();
          }
      }
  }
}
